import { render, staticRenderFns } from "./main-container.vue?vue&type=template&id=550bee24&"
import script from "./main-container.vue?vue&type=script&lang=js&"
export * from "./main-container.vue?vue&type=script&lang=js&"
import style0 from "./main-container.vue?vue&type=style&index=0&id=550bee24&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports